import React from 'react';
import {Stack, Typography} from '@mui/material';
import {IconIllustration, StyledCard} from 'presentation/components';
import {translations} from 'presentation/translations-new';

const {downloadPDFCard} = translations['pt-br'].privateFlow.myFinancial.incomeTax;

function DownloadIRCard() {
	return (
		<StyledCard.Container>
			<Stack justifyContent="center" alignItems="center" gap={2} py="61px">
				<IconIllustration variant="primary" customIconName="download" />
				<Typography variant="h6">{downloadPDFCard.title}</Typography>
				<Typography variant="body1">{downloadPDFCard.description}</Typography>
			</Stack>
		</StyledCard.Container>
	);
}

export {DownloadIRCard};
